import { useEffect } from "react";

const SITE = "https://www.indosbook.com";

const setTag = (selector, create, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const meta = (key, value, prop = "name") =>
  setTag(`meta[${prop}="${key}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute(prop, key);
    return m;
  }, "content", value);

// Per-route title, description, canonical and robots for search engines
export const usePageMeta = ({ title, description, path, noindex = false }) => {
  useEffect(() => {
    if (!title) return;
    const url = `${SITE}${path}`;
    document.title = title;
    meta("description", description);
    meta("robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
    meta("googlebot", noindex ? "noindex, follow" : "index, follow");
    meta("og:title", title, "property");
    meta("og:description", description, "property");
    meta("og:url", url, "property");
    meta("twitter:title", title);
    meta("twitter:description", description);
    setTag('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    }, "href", url);
  }, [title, description, path, noindex]);
};

export const HOME_META = {
  title: "Indosbook | Merchant Navy Jobs, Seafarer Community & Maritime Network",
  description:
    "Indosbook is the social network for the merchant navy — connect with seafarers, apply to genuine ship jobs from verified companies, and build a verified crew profile. No agents. No fees.",
  path: "/",
};
